import React, { forwardRef } from "react";
import Input from "semantic-ui-react/dist/es/elements/Input";

const VmoInput = forwardRef((props, ref) => {
  return <Input {...props} ref={ref} />;
});
export default VmoInput;
